import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useFlags } from 'launchdarkly-react-client-sdk';

import { Modal } from '../../components';
import useAuth from '../../hooks/useAuth';
import { useList } from '../../hooks/useList';
import { useSubmitForm } from '../../hooks/useSubmitForm';
import LoggedForm from './LoggedForm';
import NoLoggedForm from './NoLoggedForm';

type modalProps = {
  isOpen: boolean;
  title: string;
  description: string;
  buttonText: string;
  redirectUrl?: string | undefined;
};

export default function CreateAttendance() {
  const { t } = useTranslation('create_attendance');
  const { isLogged } = useAuth();
  const { list, isLoading } = useList();
  const { recaptchaSiteKey } = useFlags();
  const [recaptchaValue, setRecaptchaValue] = useState<string>('');

  const { error, isLoading: postLoading, onSubmit, success } = useSubmitForm({ list, xRecaptcha: recaptchaValue });
  const [modal, setModal] = useState<modalProps>({
    isOpen: false,
    title: '',
    description: '',
    buttonText: '',
    redirectUrl: undefined,
  });

  useEffect(() => {
    if (error) {
      setModal({
        isOpen: true,
        title: t('modalErrorTitle'),
        description: t('modalErrorDescription'),
        buttonText: t('modalErrorButtonText'),
        redirectUrl: undefined,
      });
    }
    if (success) {
      setModal({
        isOpen: true,
        title: t('modalSuccessTitle'),
        description: t('modalSuccessDescription'),
        buttonText: t('modalSuccessButtonText'),
        redirectUrl: '/atendimento',
      });
    }
  }, [success, error]);

  if (isLoading) {
    return <div data-testid="empty-div" />;
  }

  const handleClose = () => window.location.replace(`${window.location.origin}/atendimento`);

  return (
    <div className="matac_container" data-testid="vbz-create-attendance">
      {isLogged ? (
        <LoggedForm
          onSubmit={onSubmit}
          list={list}
          isLoading={postLoading}
          recaptchaKey={recaptchaSiteKey}
          setRecaptchaValue={setRecaptchaValue}
          recaptchaValue={recaptchaValue}
        />
      ) : (
        <NoLoggedForm
          onSubmit={onSubmit}
          list={list}
          isLoading={postLoading}
          recaptchaKey={recaptchaSiteKey}
          setRecaptchaValue={setRecaptchaValue}
          recaptchaValue={recaptchaValue}
        />
      )}
      <Modal
        buttonText={modal?.buttonText}
        description={modal?.description}
        isOpen={modal?.isOpen}
        redirectUrl={modal?.redirectUrl}
        title={modal?.title}
        handleOnClick={handleClose}
        handleOnClose={handleClose}
        toggle={handleClose}
      />
    </div>
  );
}
